const CLUSTER_TYPE = "cluster";
const USE_CASE_TYPE = "use-case";

module.exports = {
  CLUSTER_TYPE,
  USE_CASE_TYPE
};
